import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import {
    address,
    blockSpecialCharachters,
    city,
    DOCUMENT_SUPPORTED_TYPES,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    IMAGE_PROFILE_ID_SUPPORTED_TYPES,
    USER_TYPES,
    name_input,
    number_input,
    occupation_name_input,
    OTHER_MEDICAL_OCCUPATIONS,
    phoneNumber,
    RESUME_SUPPORTED_TYPES,
    textareaBox,
    zipCode
} from 'src/app/constant/constant';
import {
    boolean_medprofregistration,
    boolean_medprofUpdateDataSubmit,
    medprofFetchData,
    medprofregistration,
    medprofUpdateDataSubmit
} from 'src/app/models/medicalproffessional';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { DoctorReferralService } from 'src/app/services/doctor-referral.service';
import { DoctorRegistrationCheckerService } from 'src/app/services/doctor-registration-checker.service';
import { OthermedicalregistrationService } from 'src/app/services/othermedicalregistration.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { HttpErrorResponse } from '@angular/common/http';
import { profileFetch } from 'src/app/models/Doctorprofile';
import { saveAs } from 'file-saver';
import { Title } from '@angular/platform-browser';
import { LanguageSpoken } from 'src/app/models/doctorregistration';
import { TraceClassDecorator } from '@sentry/angular';
import { editMedProfLoginData } from 'src/app/models/medi-prof-login-edit-data';
import { ProviderStateService } from 'src/app/services/provider-state.service';
interface PrimaryOccupation {
    name: string;
}
interface SecondaryOccupation {
    name: string;
}
export interface School {
    si_no: string;
    name: string;
    year: string;
}
export interface College {
    si_no: string;
    name: string;
    year: string;
}
export interface Certifications {
    si_no: string;
    name: string;
}
export interface Hospitals {
    si_no: string;
    name: string;
}

// interface LanguageSpoken {
//   english_name: string;
//   id: number;
//   language_name: string;
//   label: string;
// }

@TraceClassDecorator()
@Component({
    selector: 'app-other-medical-profession-edit',
    templateUrl: './other-medical-profession-edit.component.html',
    styleUrls: ['../../../../../assets/css/custom-egd.css'],
    providers: [ConfirmationService, MessageService]
})
export class OtherMedicalProfessionEditComponent implements OnInit {
    readonly userTypes = USER_TYPES;
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly occupation_input: RegExp = occupation_name_input;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    readonly occupations_list = OTHER_MEDICAL_OCCUPATIONS;

    showForm = true;
    token_verified: boolean = false;
    School: School[] = [];
    College: College[] = [];
    Certifications: Certifications[] = [];
    Hospitals: Hospitals[] = [];

    years: SelectItem[] = [];
    addedOccupation: string = '';
    year = new Date().getFullYear();
    // occupation: SelectItem[] = [];
    occupations: SelectItem[] = [];
    // poccupations: PrimaryOccupation[];
    selectedpoccupation: string;
    selectedoccupations: string[] = [];
    // soccupations: SecondaryOccupation[];

    selectedsoccupation: string;

    other_primary_occupation: string;
    other_secondary_occupation: string;

    selectedCountry = null;
    countries: any = [];
    unformattedStates: any[];
    phone: any = [];
    selectedState = null;
    StatesToPractice_selectedState = null;
    selectedStateToPratice = null;
    primary_contact_number: string = '';
    secondary_contact_number: string = '';
    selectedPhoneCode_primary: string = '';
    selectedPhoneCode_secondary: string = '';
    token_string: string = null;
    temp = [];
    agree: boolean = false;
    patient_guid: any;
    states: any[];
    dateTime = new Date();
    profilePhoto: File = null;
    resume: File = null;
    profile_data_result: boolean = false;
    profile_photo_result: boolean = false;
    resume_result: boolean = false;
    success_register_display: boolean = false;
    otherreg: medprofUpdateDataSubmit;
    License_no = '';
    national_license_no: string = '';
    posting: boolean;
    loading: boolean;
    languages: LanguageSpoken[] = [];
    selected_language = [];
    national_license: boolean = false;
    recaptcha_Reset: boolean = false;
    error: ErrorModel;
    serverError: ServerError;
    response: PromiseResult;
    name = '';
    year_of_graduation = null;
    confirmDialogVisible1: boolean = false;
    confirmDialogVisible2: boolean = false;
    confirmDialogVisible3: boolean = false;
    confirmDialogVisible4: boolean = false;
    School_edit_id = -1;
    temp_School_name = '';
    temp_School_year = null;
    provider_id: string = "";
    College_edit_id = -1;
    temp_College_name = '';
    temp_College_year = null;

    certifications_name = '';
    Certifications_edit_id = -1;
    temp_certifications_name = '';
    edited_certifications_name = '';

    hospitals_name = '';
    hospitals_edit_id = -1;
    temp_hospitals_name = '';
    edited_hospitals_name = '';

    noteDialog: boolean;
    //  = true;
    othersPrimary_boolean: boolean = false;
    othersSecondary_boolean: boolean = false;

    error_message_result: PromiseResult;
    otherreg_boolean: boolean_medprofUpdateDataSubmit =
        this.doctorRegistrationCheckerService.boolean_medprofUpdateDataSubmit_init();

    user_guid: string = '';
    current_user_guid: string = '';

    avatar_url = '';
    label = '';
    resume_url = '';

    changePhoto: boolean = false;
    changePassword: boolean = false;
    changeResume: boolean = false;

    editOthers: boolean = false;
    tipsshowed: boolean = false;
    isPassword: boolean = true;

    password = '';
    confirmPassword = '';
    prevpassword = '';
    slug: string = "";

    otherreg_data: medprofFetchData;
    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    // StatesToPractice:  statestopractice[];
    editLoginData: editMedProfLoginData = new editMedProfLoginData();

    constructor(
        private countryService: CountriesService,
        private doctorsservice: DoctorsService,
        private otherMedicalRegistrationService: OthermedicalregistrationService,
        private doctorsReferralService: DoctorReferralService,
        private route: ActivatedRoute,
        private router: Router,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private readonly daterenderService: DaterenderService,
        private readonly sanitizer: DomSanitizer,
        private doctorRegistrationCheckerService: DoctorRegistrationCheckerService,
        private breadcrumbService: DoctorBreadcrumbService,
        private titleService: Title,
        private readonly providerStateService: ProviderStateService
    ) {


        for (let i = 0; i < this.occupations_list.length; i++) {
            this.occupations.push({
                label: this.occupations_list[i].toString(),
                value: this.occupations_list[i].toString()
            });
        }

        this.posting = false;
        this.loading = true;
    }

    private async GetProfileData(): Promise<void> {
        this.loading = true;
        let data: profileFetch = {
            user_guid: this.user_guid,
            current_user_guid: this.current_user_guid
        };
        await this.otherMedicalRegistrationService
            .getOtherMedicalProfileData(data)
            .toPromise()
            .then(async (result) => {
                this.response = result;
                if (this.response.success) {
                    this.otherreg_data = result.data;
                    this.editLoginData.has_verified_email = result.data.data.has_verified_email;
                    this.editLoginData.has_verified_phone = result.data.data.has_verified_phone;
                    this.editLoginData.e_email = result.data.data.d_email || "";
                    this.editLoginData.primary_contact_number = result.data.data.primary_contact_number || "";
                    this.editLoginData.country_phone_code = result.data.data.country.phone_code;
                    this.editLoginData.country_id = result.data.data.country.id;
                } else if (!this.response.success) {
                    this.error = result.error;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        sticky: true,
                        detail: result.error.code + ' : ' + result.error.message
                    });
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });

        for (const country of this.countries) {
            if (country.id == this.otherreg_data.data.country.id.toString()) {
                this.selectedCountry = country;
                break;
            }
        }

        await this.changeStates();

        this.otherreg.gender = this.otherreg_data.data.gender;
        this.otherreg.first_name = this.otherreg_data.data.first_name;
        this.otherreg.middle_name = this.otherreg_data.data.middle_name;
        this.otherreg.last_name = this.otherreg_data.data.last_name;

        this.otherreg.date_of_birth_date = new Date(
            this.otherreg_data.data.date_of_birth.replace(/-/g, '/')
        );

        if (this.otherreg_data.data?.avatar_url == null) {
            this.avatar_url = '';
        } else {
            this.avatar_url = this.otherreg_data.data.avatar_url;
        }

        this.label =
            this.otherreg.first_name +
            ' ' +
            (this.otherreg.middle_name == null ? '' : this.otherreg.middle_name) +
            ' ' +
            this.otherreg.last_name;

        this.otherreg.city = this.otherreg_data.data.city;
        this.otherreg.zip_code = this.otherreg_data.data.zip_code;
        this.otherreg.address_line_1 = this.otherreg_data.data.address_line_1;
        this.otherreg.address_line_2 = this.otherreg_data.data.address_line_2;

        for (const state of this.states) {
            if (
                state.state_name ==
                this.otherreg_data.data.state_name.toString()
            ) {
                this.selectedState = state;
                break;
            }
        }

        if (this.otherreg_data.data.other_medical_profile != null) {
            if (
                this.occupations_list.includes(
                    this.otherreg_data.data.other_medical_profile.primary_occupation.toString()
                )
            ) {
                for (const primary_occupation of this.occupations) {
                    if (
                        primary_occupation.label ==
                        this.otherreg_data.data.other_medical_profile.primary_occupation.toString()
                    ) {
                        this.selectedpoccupation =
                            primary_occupation.label.toString();
                        break;
                    }
                }
            } else if (
                !this.occupations_list.includes(
                    this.otherreg_data.data.other_medical_profile.primary_occupation.toString()
                )
            ) {
                this.selectedpoccupation = 'Others';
                this.other_primary_occupation =
                    this.otherreg_data.data.other_medical_profile.primary_occupation.toString();
            }

            if (
                Boolean(
                    this.otherreg_data.data.other_medical_profile
                        .secondary_occupation
                )
            ) {
                if (
                    this.occupations_list.includes(
                        this.otherreg_data.data.other_medical_profile.secondary_occupation.toString()
                    )
                ) {
                    for (const secondary_occupation of this.occupations) {
                        if (
                            secondary_occupation.label ==
                            this.otherreg_data.data.other_medical_profile.secondary_occupation.toString()
                        ) {
                            this.selectedsoccupation =
                                secondary_occupation.label.toString();
                            break;
                        }
                    }
                } else if (
                    !this.occupations_list.includes(
                        this.otherreg_data.data.other_medical_profile.secondary_occupation.toString()
                    )
                ) {
                    this.selectedsoccupation = 'Others';
                    this.other_secondary_occupation =
                        this.otherreg_data.data.other_medical_profile.secondary_occupation.toString();
                }
            } else if (
                !Boolean(
                    this.otherreg_data.data.other_medical_profile
                        .secondary_occupation
                )
            ) {
                this.selectedsoccupation = null;
                this.other_secondary_occupation = '';
            }

            let language_data: any[] =
                this.otherreg_data.data.other_medical_profile.language_id;
            let language_temp = [];
            let j = 0;
            for (const language of language_data) {
                for (let j = 0; j < this.languages.length; j++) {
                    if (
                        this.languages[j].id.toString() == language.toString()
                    ) {
                        language_temp.push(this.languages[j]);
                    }
                }
            }

            this.selected_language = language_temp;

            let temp_schoolEducation: any[] = [];
            for (
                let i = 0;
                i <
                this.otherreg_data.data.other_medical_profile.education.length;
                i++
            ) {
                temp_schoolEducation.push({
                    si_no: String(i + 1),
                    name: this.otherreg_data.data.other_medical_profile.education[
                        i
                    ].name.toString(),
                    year: this.otherreg_data.data.other_medical_profile.education[
                        i
                    ].year.toString()
                });
            }
            this.School = temp_schoolEducation;

            let temp_certifications: Certifications[] = [];
            for (
                let i = 0;
                i <
                this.otherreg_data.data.other_medical_profile.certifications
                    ?.length;
                i++
            ) {
                temp_certifications.push({
                    si_no: String(i + 1),
                    name: this.otherreg_data.data.other_medical_profile
                        .certifications[i]
                });
            }
            this.Certifications = temp_certifications;

            let temp_affiliated_hospitals: Hospitals[] = [];
            for (
                let i = 0;
                i <
                this.otherreg_data.data.other_medical_profile
                    .affiliated_hospitals?.length;
                i++
            ) {
                temp_affiliated_hospitals.push({
                    si_no: String(i + 1),
                    name: this.otherreg_data.data.other_medical_profile
                        .affiliated_hospitals[i]
                });
            }
            this.Hospitals = temp_affiliated_hospitals;

            if (
                this.otherreg_data.data.other_medical_profile
                    .primary_contact_number?.length > 0
            ) {
                this.primary_contact_number =
                    this.otherreg_data.data.other_medical_profile.primary_contact_number.slice(
                        -10
                    );
            }
            if (
                this.otherreg_data.data.other_medical_profile
                    .secondary_contact_number?.length > 0
            ) {
                this.secondary_contact_number =
                    this.otherreg_data.data.other_medical_profile.secondary_contact_number.slice(
                        -10
                    );
            }

            this.otherreg.license_number =
                this.otherreg_data.data.other_medical_profile.license_number;
            this.otherreg.description =
                this.otherreg_data.data.other_medical_profile.description;

            if (
                this.otherreg_data.data.other_medical_profile?.resume_url !=
                null
            )
                this.resume_url =
                    this.otherreg_data.data.other_medical_profile?.resume_url;

            this.otherreg.years_of_experience = Number(
                this.otherreg_data.data.other_medical_profile
                    .years_of_experience
            );

            this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
            this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;
            this.national_license = this.selectedCountry.is_national_license;
        }

        this.loading = false;
    }

    async ngOnInit() {
        this.titleService.setTitle(
            'Dashboard - Other Medical Professional Edit'
        );
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            {
                label: 'Dashboard',
                routerLink: [`/${this.slug}/${this.userTypes['OTHER-MEDICAL-PROFESSIONALS']}`]
            },
            { label: 'Edit Profile' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        let temp_medical_profession_guid: string;
        this.route.params.subscribe(async (params) => {
            temp_medical_profession_guid = params.user_guid;

            if (temp_medical_profession_guid != null) {
                this.user_guid = temp_medical_profession_guid;
                this.current_user_guid = sessionStorage.getItem('userid');
                this.editOthers = true;
            } else {
                this.user_guid = sessionStorage.getItem('userid');
                this.current_user_guid = sessionStorage.getItem('userid');
                this.editOthers = false;
            }
        });
        for (let i = 1900; i <= this.year; i++) {
            this.years.push({ label: i.toString(), value: i.toString() });
        }

        this.years.reverse();

        this.dateTime.setDate(this.dateTime.getDate());
        this.dateTime.setFullYear(this.dateTime.getFullYear() - 18);
        this.otherreg = {
            guid: {
                user_guid: null,
                current_user_guid: null
            },
            current_user_guid: null,
            is_password: false,
            d_password: '',
            prev_password: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            gender: '',
            date_of_birth: null,
            date_of_birth_date: null,
            country_id: null,
            state_name: null,
            city: '',
            address_line_1: '',
            address_line_2: '',
            zip_code: '',
            certifications: [],
            education: [],
            affiliated_hospitals: [],
            license_number: '',
            primary_occupation: null,
            secondary_occupation: null,
            description: '',
            primary_contact_number: '',
            secondary_contact_number: '',
            years_of_experience: null,
            recaptcha: '',
            language_id: []
        };

        this.otherreg_boolean =
            await this.doctorRegistrationCheckerService.boolean_medprofUpdateDataSubmit_init();
        this.editLoginData = new editMedProfLoginData();
        await this.recaptchaReset();
        await this.getLanguages();
        await this.getCountries();
        await this.recaptchaReset();

        this.School = [];
        this.College = [];
        this.Hospitals = [];
        this.Certifications = [];
        await this.GetProfileData();
    }
    displaySchool: boolean = false;
    editdisplaySchool: boolean = false;
    displayCollege: boolean = false;
    editdisplayCollege: boolean = false;
    displayCertifications: boolean = false;
    displayAffiliatedHospitals: boolean = false;

    showAddSchoolDialog() {
        this.displaySchool = true;
    }
    showAddCollegeDialog() {
        this.displayCollege = true;
    }
    showAddCertificationsDialog() {
        this.displayCertifications = true;
    }
    showAddAffiliatedHospitalsDialog() {
        this.displayAffiliatedHospitals = true;
    }

    getBoolean(a, b): boolean {
        return a === b;
    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.error_message_result = {
            success: null,
            error: null,
            data: null
        };
    }

    showDialog() {
        this.success_register_display = true;
    }

    close() {
        this.displaySchool = false;
        this.displayCollege = false;
        this.displayCertifications = false;
        this.displayAffiliatedHospitals = false;
        this.resetDialog();
    }

    resetDialog() {
        this.name = '';
        this.year_of_graduation = null;
        this.License_no = '';

        this.hospitals_name = '';
        this.year_of_graduation = null;
        this.certifications_name = '';

        this.temp_School_name = '';
        this.temp_School_year = null;

        this.temp_College_name = '';
        this.temp_College_year = null;

        this.edited_certifications_name = '';
        this.temp_certifications_name = '';

        this.edited_hospitals_name = '';
        this.temp_hospitals_name = '';
    }

    addSchool() {
        this.School.push({
            si_no: (this.School.length + 1).toString(),
            name: this.name,
            year: this.year_of_graduation.toString()
        });
        this.name = '';
        this.year_of_graduation = null;
    }
    addCollege() {
        this.College.push({
            si_no: (this.College.length + 1).toString(),
            name: this.name,
            year: this.year_of_graduation.toString()
        });
        this.name = '';
        this.year_of_graduation = null;
    }
    addCertifications() {
        this.Certifications.push({
            si_no: (this.Certifications.length + 1).toString(),
            name: this.certifications_name
        });
        this.certifications_name = '';
    }
    addAffiliatedHospitals() {
        this.Hospitals.push({
            si_no: (this.Hospitals.length + 1).toString(),
            name: this.hospitals_name
        });
        this.hospitals_name = '';
    }

    deleteSchool(row) {
        let temp: School[] = [];
        let j;
        for (let i = 0; i < this.School.length; i++) {
            if (
                this.School[i].name != row.name &&
                this.School[i].year != row.year
            ) {
                temp.push(this.School[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.School.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.School[i].name,
                year: this.School[i].year
            });
        }
        this.School = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteCollege(row) {
        let temp: College[] = [];
        let j;
        for (let i = 0; i < this.College.length; i++) {
            if (
                this.College[i].name != row.name &&
                this.College[i].year != row.year
            ) {
                temp.push(this.College[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.College.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.College[i].name,
                year: this.College[i].year
            });
        }
        this.College = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteCertifications(row) {
        let temp: Certifications[] = [];
        let j;
        for (let i = 0; i < this.Certifications.length; i++) {
            if (this.Certifications[i].name != row.name) {
                temp.push(this.Certifications[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Certifications.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.Certifications[i].name
            });
        }
        this.Certifications = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteAffiliatedHospitals(row) {
        let temp: Hospitals[] = [];
        let j;
        for (let i = 0; i < this.Hospitals.length; i++) {
            if (this.Hospitals[i].name != row.name) {
                temp.push(this.Hospitals[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Hospitals.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.Hospitals[i].name
            });
        }
        this.Hospitals = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    canceleditData(id, form: string) {
        if (form == 'School') {
            this.School_edit_id = -1;
            this.School[id - 1].name = this.temp_School_name;
            this.School[id - 1].year = this.temp_School_year;
            this.editdisplaySchool = false;
            this.name = '';
            this.year_of_graduation = null;
            this.temp_School_name = '';
            this.temp_School_year = null;
        } else if (form == 'College') {
            this.College_edit_id = -1;
            this.College[id - 1].name = this.temp_College_name;
            this.College[id - 1].year = this.temp_College_year;
            this.editdisplayCollege = false;
            this.name = '';
            this.year_of_graduation = null;
            this.temp_College_name = '';
            this.temp_College_year = null;
        } else if (form == 'Certifications') {
            this.Certifications_edit_id = -1;
            this.Certifications[id - 1].name = this.temp_certifications_name;
            this.edited_certifications_name = '';
            this.temp_certifications_name = '';
        } else if (form == 'Hospitals') {
            this.hospitals_edit_id = -1;
            this.Hospitals[id - 1].name = this.temp_hospitals_name;
            this.edited_hospitals_name = '';
            this.temp_hospitals_name = '';
        }
    }

    saveData(id, form: string) {
        if (form == 'School') {
            this.School[id - 1].name = this.name;
            this.School[id - 1].year = this.year_of_graduation;
            this.School_edit_id = -1;
            this.name = '';
            this.year_of_graduation = null;
            this.editdisplaySchool = false;
            this.temp_School_name = '';
            this.temp_School_year = null;
        } else if (form == 'College') {
            this.College[id - 1].name = this.name;
            this.College[id - 1].year = this.year_of_graduation;
            this.College_edit_id = -1;
            this.name = '';
            this.year_of_graduation = null;
            this.editdisplayCollege = false;
            this.temp_College_name = '';
            this.temp_College_year = null;
        } else if (form == 'Certifications') {
            this.Certifications[id - 1].name = this.edited_certifications_name;
            this.Certifications_edit_id = -1;
            this.edited_certifications_name = '';
            this.temp_certifications_name = '';
        } else if (form == 'Hospitals') {
            this.Hospitals[id - 1].name = this.edited_hospitals_name;
            this.hospitals_edit_id = -1;
            this.edited_hospitals_name = '';
            this.temp_hospitals_name = '';
        }
    }

    editData(id, form: string) {
        if (form == 'School') {
            this.School_edit_id = id;
            this.temp_School_name = this.School[id - 1].name;
            this.temp_School_year = this.School[id - 1].year;
            this.name = this.temp_School_name;
            this.year_of_graduation = this.temp_School_year.toString();
            this.editdisplaySchool = true;
        } else if (form == 'College') {
            this.College_edit_id = id;
            this.temp_College_name = this.College[id - 1].name;
            this.temp_College_year = this.College[id - 1].year;
            this.name = this.temp_College_name;
            this.year_of_graduation = this.temp_College_year.toString();
            this.editdisplayCollege = true;
        } else if (form == 'Certifications') {
            this.Certifications_edit_id = id;
            this.temp_certifications_name = this.Certifications[id - 1].name;
            this.edited_certifications_name = this.temp_certifications_name;
        } else if (form == 'Hospitals') {
            this.hospitals_edit_id = id;
            this.temp_hospitals_name = this.Hospitals[id - 1].name;
            this.edited_hospitals_name = this.temp_hospitals_name;
        }
    }

    confirmSchoolSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-School',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteSchool(product);
            }
        });
    }

    confirmCollegeSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-College',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteCollege(product);
            }
        });
    }

    confirmCertificationsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-certifications',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteCertifications(product);
            }
        });
    }

    confirmAffiliatedHospitalsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-affiliatedhospitals',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteAffiliatedHospitals(product);
            }
        });
    }

    async changeStates() {
        this.unformattedStates = [];
        this.states = [];
        this.temp = [];
        this.phone = [];
        this.selectedState = null;
        this.selectedStateToPratice = null;
        this.national_license = this.selectedCountry.is_national_license;
        this.national_license_no = '';

        await this.countryService
            .getStates(this.selectedCountry.id)
            .toPromise()
            .then((states) => (this.unformattedStates = states));

        if (this.unformattedStates.length > 0) {

            for (let i = 0; i < this.unformattedStates.length; i++) {
                this.temp.push({
                    state_name: this.unformattedStates[i].state_name,
                    state_id: this.unformattedStates[i].id
                });
            }
            this.states = this.temp;
        } else {
            // this.statesInput=true;
            // this.statesInputDisabled=false;
        }

        this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
        this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;
    }

    async getLanguages() {
        await this.doctorsservice
            .GetLanguageSpoken()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    let temp_languages: LanguageSpoken[] = [];
                    for (let i = 0; i < result.data.length; i++) {
                        let temp: LanguageSpoken = {
                            id: result.data[i].id,
                            language_name: result.data[i].language_name,
                            english_name: result.data[i].english_name,
                            label:
                                result.data[i].english_name +
                                '(' +
                                result.data[i].language_name +
                                ')'
                        };
                        temp_languages.push(temp);
                    }
                    this.languages = temp_languages;
                }
            });
    }

    async getCountries() {
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((countries) => {
                this.countries = countries;
                countries.forEach((ele) => {
                    ele["final_phone_code"] = '+' + String(ele.phone_code);
                    ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
                    this.editLoginData.country_codes.push({
                        id: Number(ele.id),
                        value: {
                            label: ele["final_label_string"],
                            value: ele["final_phone_code"],
                        }
                    });
                });
            });
    }
    async getStates(country_id) {
        await this.countryService
            .getStates(country_id)
            .toPromise()
            .then((states) => (this.unformattedStates = states));
    }
    uploadProfileFiles(file: File[]) {
        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.profilePhoto = null;
            } else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.profilePhoto = file[0];
            }
        } else {
            this.profilePhoto = null;
        }
    }

    onRemovePhoto() {
        this.profilePhoto = null;
    }

    uploadResumeFiles(file: File[]) {
        if (this.resume_types.includes(file[0].type.toLowerCase())) {
            // this.resume = file[0];
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.resume = null;
            } else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.resume = file[0];
            }
        } else {
            this.resume = null;
        }
    }

    onRemoveResume() {
        this.resume = null;
    }
    async recaptchaReset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000);
    }

    resolved(captchaResponse: any) {
        this.otherreg.recaptcha = captchaResponse;
    }
    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }

    onAgreeChange(Event: Event) {
        this.agree = Boolean(Event);
    }

    async addNewOccupation() {
        const temp: SelectItem[] = this.occupations;

        let tempaddedOccupation = this.addedOccupation
            .trim()
            .toLowerCase()
            .split(' ');
        for (let i = 0; i < tempaddedOccupation.length; i++) {
            tempaddedOccupation[i] =
                tempaddedOccupation[i][0].toUpperCase() +
                tempaddedOccupation[i].slice(1);
        }
        let b = tempaddedOccupation.join(' ');
        //  code for /

        let tempOccupationsName: string[] = [];
        for (let i = 0; i < temp.length; i++) {
            tempOccupationsName.push(temp[i].label);
        }
        tempOccupationsName.push(b);
        // this.selectedoccupations.push(b.toString());

        let tempOccupations = Array.from(new Set(tempOccupationsName)).sort();
        let temp1: SelectItem[] = [];
        for (let i = 0; i < tempOccupations.length; i++) {
            temp1.push({
                label: tempOccupations[i].toString(),
                value: tempOccupations[i].toString()
            });
        }
        this.occupations = temp1;
        this.addedOccupation = '';
    }

    async submitData(): Promise<void> {
        await this.recaptchaReset();
        await this.ResetResultModels();
        this.posting = true;

        this.otherreg.guid = {
            user_guid: this.user_guid,
            current_user_guid: this.current_user_guid
        };

        this.otherreg.current_user_guid = this.otherreg.guid.current_user_guid;

        // Password
        if (this.changePassword) {
            this.otherreg.is_password = true;
            this.otherreg.d_password = this.password;
        } else if (!this.changePassword) {
            this.otherreg.is_password = false;
            this.otherreg.d_password = '';
        }

        if (this.otherreg.date_of_birth_date == null) {
            this.otherreg.date_of_birth = null;
        } else if (this.otherreg.date_of_birth_date != null) {
            this.otherreg.date_of_birth = this.daterenderService.render_data(
                this.otherreg.date_of_birth_date
            );
        }

        if (this.selectedCountry == null) {
            this.otherreg.country_id = null;
        } else if (this.selectedCountry != null) {
            this.otherreg.country_id = Number(this.selectedCountry.id);
        }

        if (this.selectedState == null) {
            this.otherreg.state_name = null;
        } else if (this.selectedState != null) {
            this.otherreg.state_name = this.selectedState.state_name;
        }

        if (this.selectedpoccupation == null) {
            this.otherreg.primary_occupation = null;
        } else if (this.selectedpoccupation != null) {
            this.othersPrimary_boolean = false;
            if (
                this.getBoolean(
                    this.selectedpoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                if (this.other_primary_occupation?.length > 0) {
                    this.otherreg.primary_occupation =
                        this.other_primary_occupation;
                } else {
                    this.otherreg.primary_occupation = '';
                    this.othersPrimary_boolean = true;
                }
            } else if (
                !this.getBoolean(
                    this.selectedpoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                this.otherreg.primary_occupation = this.selectedpoccupation;
            }
        }

        if (this.selectedsoccupation == null) {
            this.otherreg.secondary_occupation = null;
        } else if (this.selectedsoccupation != null) {
            this.othersSecondary_boolean = false;
            if (
                this.getBoolean(
                    this.selectedsoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                if (this.other_secondary_occupation?.length > 0) {
                    this.otherreg.secondary_occupation =
                        this.other_secondary_occupation;
                } else {
                    this.otherreg.secondary_occupation = '';
                    this.othersSecondary_boolean = true;
                }
            } else if (
                !this.getBoolean(
                    this.selectedsoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                this.otherreg.secondary_occupation = this.selectedsoccupation;
            }
        }

        let tempselectedLanguageSpoken: number[] = [];
        if (this.selected_language.length > 0) {
            for (let i = 0; i < this.selected_language?.length; i++) {
                tempselectedLanguageSpoken.push(
                    Number(this.selected_language[i].id)
                );
            }
        }

        this.otherreg.language_id = tempselectedLanguageSpoken;

        // this.otherreg.date_of_birth = this.daterenderService.render_data(this.otherreg.date_of_birth);
        // this.otherreg.country_id = this.selectedCountry.id;
        if (this.otherreg.years_of_experience == null) {
            this.otherreg.years_of_experience = null;
        } else if (this.otherreg.years_of_experience != null) {
            this.otherreg.years_of_experience = Number(
                this.otherreg.years_of_experience
            );
        }

        // this.otherreg.state_name = this.selectedState.state_name;
        // }

        this.otherreg.education = this.School;

        let tempCertifications: string[] = [];
        for (let i = 0; i < this.Certifications.length; i++) {
            //  this.otherreg.board_certification.push(this.Board[i].name)
            tempCertifications.push(this.Certifications[i].name);
        }
        this.otherreg.certifications = tempCertifications;

        let tempAffiliatedHospitals: string[] = [];
        for (let i = 0; i < this.Hospitals.length; i++) {
            //  this.otherreg.board_certification.push(this.Board[i].name)
            tempAffiliatedHospitals.push(this.Hospitals[i].name);
        }
        this.otherreg.affiliated_hospitals = tempAffiliatedHospitals;

        if (this.primary_contact_number?.length > 0) {
            this.otherreg.primary_contact_number =
                '+' +
                this.selectedPhoneCode_primary +
                this.primary_contact_number.slice(-10);
        }
        if (this.secondary_contact_number?.length > 0) {
            this.otherreg.secondary_contact_number =
                '+' +
                this.selectedPhoneCode_secondary +
                this.secondary_contact_number.slice(-10);
        }

        // this.otherreg.license_number = "license";
        // this.otherreg.token = this.token_string;

        this.otherreg_boolean =
            await this.doctorRegistrationCheckerService.OtherMedicalUpdateFormSubmitChecker(
                this.otherreg,
                false,
                this.changePhoto,
                this.profilePhoto,
                this.changeResume,
                this.resume,
                this.password,
                this.confirmPassword
            );
        this.error_message_result =
            await this.doctorRegistrationCheckerService.getOtherMedicalUpdateFormErrors(
                this.otherreg_boolean
            );
        if (this.othersPrimary_boolean || this.othersSecondary_boolean) {
            this.error_message_result.success = false;
            if (this.othersPrimary_boolean) {
                this.error_message_result.data.push(
                    'Enter the Primary Occupation.'
                );
            }
            if (this.othersSecondary_boolean) {
                this.error_message_result.data.push(
                    'Enter the Secondary Occupation.'
                );
            }
        }
        if (!Boolean(this.error_message_result.success)) {
            this.posting = false;
        } else if (Boolean(this.error_message_result.success)) {
            await this.uploadData();
        }
    }

    async uploadData() {
        let a: boolean = true;

        await this.otherMedicalRegistrationService
            .updateOtherMedicalProfileData(this.otherreg)
            .toPromise()
            .then((result) => {
                this.response = result;
                this.profile_data_result = this.response.success;
                if (this.response.success) {

                }

            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });

        if (
            this.profile_data_result != null &&
            this.profile_data_result == false
        ) {
            this.posting = false;
            return;
        }

        if (this.profilePhoto != null) {
            let formPhoto: FormData = new FormData();
            formPhoto.set(
                'current_user_guid',
                this.otherreg.guid.current_user_guid
            );
            formPhoto.set('file', this.profilePhoto);

            await this.doctorsservice
                .UploadDoctorProfilePhoto(
                    formPhoto,
                    this.otherreg.guid.user_guid
                )
                .toPromise()
                .then((result) => {
                    this.response = result;
                    if (this.response.success) {
                        this.profile_photo_result = this.response.success;
                        // this.otherreg.user_guid = result.data.user_guid;
                    }
                })
                .catch((error: HttpErrorResponse) => {
                    this.serverError = error.error;
                    this.response.success = false;
                    this.posting = false;
                });

            if (
                this.profile_photo_result != null &&
                this.profile_photo_result == false
            ) {
                this.posting = false;
                return;
            }
        }

        if (this.resume != null) {
            let formResume: FormData = new FormData();
            formResume.set(
                'current_user_guid',
                this.otherreg.guid.current_user_guid
            );
            formResume.set('file', this.resume);

            await this.otherMedicalRegistrationService
                .updateOtherMedicalResume(
                    formResume,
                    this.otherreg.guid.user_guid
                )
                .toPromise()
                .then((result) => {
                    this.response = result;
                    if (this.response.success) {
                        this.resume_result = this.response.success;
                    }
                })
                .catch((error: HttpErrorResponse) => {
                    this.serverError = error.error;
                    this.response.success = false;
                    this.posting = false;
                });

            if (this.resume_result != null && this.resume_result == false) {
                this.posting = false;
                return;
            }
        }

        if (
            this.profile_data_result ||
            this.profile_photo_result ||
            this.resume_result
        ) {
            this.showForm = false;
            this.success_register_display = true;
            this.showDialog();
        }
    }

    async submitDoctorRegistration() {
        let waitSec = Number((Math.floor(Math.random() * 1000) + 1) % 3);
        this.posting = true;
        await setTimeout(async () => {
            this.submitData();
        }, 5000 + waitSec);
    }

    download(url: string, name: string) {
        const Url = url;
        const Name = name;
        saveAs(Url, Name);
    }

    changeType() {
        this.isPassword = !this.isPassword;
    }

    gotodashboard() {
        this.RouterNavigation('/' + this.slug +
            '/' + this.userTypes['OTHER-MEDICAL-PROFESSIONALS'] + '/dashboard'
        );
    }

    showTips() {
        this.tipsshowed = !this.tipsshowed;
    }

    async RestoreData() {
        // if (JSON.parse(localStorage.getItem("Referral")) == null) {
        //   this.masterChecker = false;
        // }
        // else if (JSON.parse(localStorage.getItem("Referral")) != null) {
        //   await this.NullChecker();
        // }
        // if (this.masterChecker) {
        //   // if (event.defaultPrevented) return;
        //   // event.preventDefault();
        //   await this.confirmationService.confirm({
        //     key: 'confirm-local-data',
        //     message: 'Are you sure you want to restore previous filled data?',
        //     icon: 'pi pi-exclamation-triangle',
        //     accept: async () => {
        //       await this.getLocalProfileData();
        //     },
        //   });
        // }
    }
}
